<template>
    <div class="af-job-apply-personal-info">
        <div class="afu-grid afu-grid-cols-1 md:afu-grid-cols-2 md:afu-gap-8">
            <C1FormGroup>
                <ValidationProvider
                    v-slot="{ errors }"
                    name="First name"
                    rules="required"
                >
                    <C1FormInput
                        v-model="applyFirstName"
                        :is-invalid="!!errors[0]"
                        :invalid-feedback="errors[0]"
                        name="first_name"
                        :label="$t('label.first_name')"
                        :placeholder="$t('label.first_name_placeholder')"
                    />
                </ValidationProvider>
            </C1FormGroup>
            <C1FormGroup>
                <ValidationProvider
                    v-slot="{ errors }"
                    name="Last name"
                    rules="required"
                >
                    <C1FormInput
                        v-model="applyLastName"
                        :is-invalid="!!errors[0]"
                        :invalid-feedback="errors[0]"
                        name="last_name"
                        :label="$t('label.last_name')"
                        :placeholder="$t('label.last_name_placeholder')"
                    />
                </ValidationProvider>
            </C1FormGroup>
        </div>
        <div class="af-job-apply-form-personal-info afu-grid afu-grid-cols-1 md:afu-grid-cols-2 md:afu-gap-8">
            <C1FormGroup>
                <ValidationProvider
                    v-slot="{ errors }"
                    name="Email"
                    rules="required"
                >
                    <C1FormInput
                        v-model="applyEmail"
                        :is-invalid="!!errors[0]"
                        :invalid-feedback="errors[0]"
                        name="email"
                        :label="$t('label.email_address')"
                        :placeholder="$t('label.email_address_placeholder')"
                        :disabled="disableEmail()"
                    />
                </ValidationProvider>
            </C1FormGroup>
            <C1FormGroup>
                <ValidationProvider
                    v-slot="{ errors }"
                    name="Contact number"
                    rules="required|phone_number"
                >
                    <C1FormInput
                        v-model="applyContactNumber"
                        :is-invalid="!!errors[0]"
                        :invalid-feedback="errors[0]"
                        name="contact_number"
                        :label="$t('label.contact_number')"
                        :placeholder="$t('label.contact_number_placeholder')"
                    />
                </ValidationProvider>
            </C1FormGroup>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {mapState, mapMutations, mapGetters} from 'vuex';
    import { ValidationProvider } from 'vee-validate';
    import C1FormInput from '@/components/C1Components/C1FormInput';
    import C1FormGroup from '@/components/C1Components/C1FormGroup';

    export default {
        name: 'ApplyPersonalInfo',

        components: {
            ValidationProvider,
            C1FormInput,
            C1FormGroup,
        },

        computed: {
            ...mapState({
                $_me: state => state.me.user,
                $_applyUser: state => state.jobApplication.user,
            }),

            applyEmail: {
                get() {
                    return this.$_applyUser.email || this.$_me.email;
                },
                set(newValue) {
                    Vue.set(this.$store.state.jobApplication.user, 'email', newValue);
                },
            },

            applyFirstName: {
                get() {
                    return this.$_applyUser.first_name || this.$_me.first_name;
                },
                set(newValue) {
                    Vue.set(this.$store.state.jobApplication.user, 'first_name', newValue);
                    // this.$_STORE_APPLY_USER({key: 'first_name', value: newValue});
                },
            },

            applyLastName: {
                get() {
                    return this.$_applyUser.last_name || this.$_me.last_name;
                },
                set(newValue) {
                    // this.$_STORE_APPLY_USER({key: 'last_name', value: newValue});
                    Vue.set(this.$store.state.jobApplication.user, 'last_name', newValue);
                },
            },

            applyContactNumber: {
                get() {
                    return this.$_applyUser.contact_number || this.$_me.contact_number;
                },
                set(newValue) {
                    Vue.set(this.$store.state.jobApplication.user, 'contact_number', newValue);
                    // this.$_STORE_APPLY_USER({key: 'contact_number', value: newValue});
                },
            },
        },

        methods: {
            ...mapMutations('jobApplication', {
                $_STORE_APPLY_USER: 'STORE_APPLY_USER',
            }),

            ...mapGetters('jobApplication', {
                $_isApplyAsGuestUser: 'isApplyAsGuestUser',
            }),

            disableEmail: function() {
                return !!(!this.$_isApplyAsGuestUser() && this.applyEmail);
            },
        },
    };
</script>
